import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  Host,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Icons } from '@app/shared/constants';
import { ButtonToggleOptionIcon } from '@components/buttons/button-toggle-group/button-toggle-group.component';
import { Subscription } from 'rxjs';
import { DataTableNewComponent, DataTableView } from '../data-table-new.component';
import { DataTableState } from '../state/state.model';
import { StateService } from '../state/state.service';

@Directive({ selector: '[vfsDatatableSwitchView]', exportAs: 'vfsDatatableSwitchView' })
export class DatatableSwitchViewDirective implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  switchOptions: ButtonToggleOptionIcon[] = [
    {
      icon: Icons.VIEW_LIST,
      value: DataTableView.GRID
    },
    {
      icon: Icons.VIEW_MODULE,
      value: DataTableView.CARD
    }
  ];

  stateId: string;
  switchViewToggleSubscription: Subscription;

  constructor(
    @Host() private parent: DataTableNewComponent<any>,
    @Inject('StateService') private stateService: StateService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.stateId = this.parent.stateId;
    this.parent.withSwitchView = true;
  }

  ngAfterViewInit() {
    this.parent.switchViewToggle.optionsIcon = this.switchOptions;

    // Fill the initial value of the toggle with the status value, if present
    const state: DataTableState = this.stateService.get(this.stateId);
    if (state.view) {
      this.parent.currentView = state.view;
    } else {
      state.view = this.parent.currentView;
      this.stateService.update(state);
    }

    this.performCheck();

    this.parent.switchViewToggle.changeValue.subscribe(value => {
      // Update the status with the new view value
      const currentState: DataTableState = this.stateService.get(this.stateId);
      currentState.view = value;
      this.stateService.update(currentState);

      this.parent.currentView = value;
      this.performCheck();
    });
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.switchViewToggleSubscription) {
      this.switchViewToggleSubscription.unsubscribe();
    }
  }

  private performCheck() {
    this.switchOptions.forEach((option: ButtonToggleOptionIcon) => {
      option.checked = option.value === this.parent.currentView;
    });
  }
}
